// extracted by mini-css-extract-plugin
export default {"box":"xfeqN8","image":"TUAjI1","modal":"jeePpd","x":"NdWsOj"};